import { RuleOperator, RuleValueType, Severity } from '../../modules/protocols/models/Protocol'

// Display labels only: the stored values stay technical (heart_rate, gt...).

const OPERATOR_KEY: Record<RuleOperator, string> = {
  [RuleOperator.Equal]: 'opEqual',
  [RuleOperator.NotEqual]: 'opNotEqual',
  [RuleOperator.Greater]: 'opGreater',
  [RuleOperator.Lower]: 'opLower',
  [RuleOperator.GreaterEqual]: 'opGreaterEqual',
  [RuleOperator.LowerEqual]: 'opLowerEqual',
  [RuleOperator.TrendUp]: 'opTrendUp',
  [RuleOperator.TrendDown]: 'opTrendDown',
  [RuleOperator.In]: 'opIn',
}

const VALUE_TYPE_KEY: Record<RuleValueType, string> = {
  [RuleValueType.Num]: 'numValue',
  [RuleValueType.String]: 'stringValue',
  [RuleValueType.List]: 'listValue',
}

const PARAMETER_KEY: Record<string, string> = {
  heart_rate: 'paramHeartRate',
  steps: 'paramSteps',
  spo2: 'paramSpo2',
  sleep_minutes: 'paramSleepMinutes',
  calories: 'paramCalories',
  active_minutes: 'paramActiveMinutes',
}

type Translator = (key: string) => string

export const operatorLabel = (t: Translator, op: RuleOperator | string): string => {
  const key = OPERATOR_KEY[op as RuleOperator]
  return key ? t(key) : String(op)
}

// Fallback for a parameter the backend adds and this list does not know yet.
const readable = (p: string) => p.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase())

export const valueTypeLabel = (t: Translator, type: RuleValueType | string): string => {
  const key = VALUE_TYPE_KEY[type as RuleValueType]
  return key ? t(key) : String(type)
}

export const severityLabel = (t: Translator, s: Severity | string): string =>
  s === Severity.Alarm ? t('severityAlarm') : t('severityWarning')

export const parameterLabel = (t: Translator, parameter: string): string => {
  if (!parameter) return ''
  const key = PARAMETER_KEY[parameter]
  if (!key) return readable(parameter)
  const translated = t(key)
  // i18next returns the key itself when it cannot find it.
  return translated === key ? readable(parameter) : translated
}
